export default {
  data() {
    return {
      endTime: '23:59:59',
      social: {
        vk: {
          name: 'Vkontakte',
          color: '#069df2',
        },
        tw: {
          name: 'Твиттер',
          color: '#1be5f2',
        },
        fb: {
          name: 'Facebook',
          color: '#3b5998',
        },
        gs: {
          name: 'СМИ',
          color: '#601b95',
        },
      },
      dataLineCollection: {},
      dataBarCollection: {},
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 10,
              fontFamily: "Oswald",
              fontStyle: "bold",
              beginAtZero:true
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              display: false,
            },
          }],
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 10,
              fontFamily: "Oswald",
              fontStyle: "bold",
              beginAtZero:true
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              display: false,
            },
          }],
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    };
  },
  methods: {
    prepareLineChartData(response, prepareLabels = elem => elem[0]) {
      const datasets = [];
      const labels = response.data.total.total.map(elem => prepareLabels(elem));

      for (const socialName in this.social) {
        if (response.data[socialName]) {
          datasets.push(this.prepareLineChartDataItem(socialName, response.data));
        }
      }

      return {
        labels,
        datasets,
      };
    },
    prepareBarChartData(response, prepareLabels = elem => elem[0]) {
      const labels = response.data.total.total.map(elem => prepareLabels(elem));

      const tonalKeys = response.data.total.total.length - 1;
      const socialKeys = Object.keys(this.social);
      const data = {
        positive: [],
        negative: [],
        netural: [],
      };


      for (let i = 0; i <= tonalKeys; i++) {
        let positive = 0;
        let negative = 0;
        let netural = 0;

        socialKeys.forEach((socialKey) => {
          if (response.data[socialKey]) {
            positive += response.data[socialKey].positive[i][1];
            negative += response.data[socialKey].negative[i][1];
            netural += response.data[socialKey].netural[i][1];
          }
        });

        data.positive.push(positive);
        data.negative.push(negative);
        data.netural.push(netural);
      }

      return {
        labels,
        datasets: this.prepareBarChartDataItem(data),
      };
    },
    prepareLineChartDataItem(social, data) {
      return {
        label: this.social[social].name,
        borderColor: this.social[social].color,
        pointBackgroundColor: this.social[social].color,
        lineTension: 0,
        backgroundColor: 'transparent',
        data: data[social].total.map(elem => elem[1]),
      };
    },
    prepareBarChartDataItem(tonalData) {
      return [
        {
          label: 'Позитивные',
          backgroundColor: '#03bb9a',
          data: tonalData.positive,
        },
        {
          label: 'Нейтральные',
          backgroundColor: '#c4c4c4',
          data: tonalData.netural,
        },
        {
          label: 'Негативные',
          backgroundColor: '#ed002b',
          data: tonalData.negative,
        },
      ];
    },
    setParams(id, range = null) {
      if (range) {
        if (range.to) {
          return {
            thread_id: id,
            from: range.from,
            to: range.to,
          };
        }

        return {
          thread_id: id,
          from: range.from,
        };
      }

      return {
        thread_id: id,
      };
    },
  },
};
